import { webLogPost } from './web-log';

export function logError(err: unknown) {
  // eslint-disable-next-line no-console
  console.error(err);

  const message = err instanceof Error ? err.message : String(err);
  const attributes =
    err instanceof Error
      ? {
          name: err.name,
          stack: err.stack,
        }
      : undefined;

  webLogPost({ attributes, level: 'error', message });
}
